<header>
  <div class="header-wrapper">
    <div class="header-upper" [class.authenticated]="auth.isAuthenticated()">
      <div class="flex">
        <app-back-button></app-back-button>
        <a
          class="logo"
          *ngIf="headerData && headerData['logo']"
          routerLink="/"
          [class.disabled]="disableLogoLink()"
        >
          <img src="{{ headerData['logo']?.data?.attributes?.url }}" />
        </a>
      </div>

      <div class="desktop-actions">
        <h4 class="subtitle-text">
          {{ headerData?.subtitle ?? 'Howden for Students' }}
        </h4>

        <div class="shortcuts-container" *ngIf="auth.isAuthenticated()">
          <a
            *ngIf="showMyInsuranceButton"
            class="btn-wrapper"
            [routerLink]="'/app/my-insurance'"
            [routerLinkActive]="'is-active'"
          >
            <button type="button" class="btn btn-white-outline">
              My insurance
              <span
                >(<span class="header-cover-count">{{
                  auth.currentUser?.coverCount
                }}</span
                >)</span
              >
            </button>
          </a>
          <a
            class="btn-wrapper"
            [routerLink]="'/app/my-profile'"
            [routerLinkActive]="'is-active'"
          >
            <button type="button" class="btn btn-white-outline">
              My profile
            </button>
          </a>
        </div>
      </div>

      <div class="mobile-actions">
        <a *ngIf="auth.isAuthenticated()" (click)="toggleNav()">
          <img
            *ngIf="!showMobileMenu"
            class="mobile-menu-icon"
            src="/assets/icons/hb-menu.svg"
          />
          <img
            *ngIf="showMobileMenu"
            class="mobile-menu-icon"
            src="/assets/icons/close-btn-white.svg"
          />
        </a>
      </div>
    </div>
    <div class="header-lower" [class.authenticated]="auth.isAuthenticated()">
      <!-- main nav (mobile) -->
      <div class="mobile-subtitle" [class.hide]="showMobileMenu">
        <h4 class="subtitle-text">
          {{ headerData?.subtitle ?? 'Howden for Students' }}
        </h4>
      </div>

      <nav
        class="main-nav-mobile"
        [class.show]="showMobileMenu"
        *ngIf="auth.isAuthenticated()"
      >
        <p *ngIf="mobileMenuError" class="nav-error">
          Error loading main menu. Please refresh the page.
        </p>
        <div class="burger-nav">
          <div
            class="standard-routes"
            *ngFor="let link of mobileMainMenu?.menu_items"
          >
            <app-cms-link
              class="navbar mobile-route"
              [routeArrow]="true"
              [link]="link"
              [class]="'primary'"
              (click)="this.showMobileMenu = false"
            >
              {{ link.label }}
            </app-cms-link>
          </div>
          <div class="button-routes">
            <a
              *ngIf="mobileMyInsurance && showMyInsuranceButton"
              [routerLink]="mobileMyInsurance.route"
            >
              <button class="btn" type="button">
                {{ mobileMyInsurance.label }}
                <span *ngIf="auth.currentUser?.coverCount">
                  (<span class="header-cover-count">{{
                    auth.currentUser?.coverCount
                  }}</span
                  >)
                </span>
              </button>
            </a>
            <a *ngIf="mobileMyProfile" [routerLink]="mobileMyProfile.route">
              <button class="btn" type="button">
                {{ mobileMyProfile.label }}
              </button>
            </a>
          </div>
        </div>
      </nav>

      <!-- main nav (desktop) -->
      <nav
        class="main-nav-desktop"
        *ngIf="auth.isAuthenticated() && navigationMenu"
      >
        <div *ngFor="let link of navigationMenu?.menu_items">
          <app-cms-link class="navbar" [link]="link">{{
            link.label
          }}</app-cms-link>
        </div>
      </nav>
      <nav class="main-nav-desktop" *ngIf="navigationMenuError">
        <p>Error loading main menu. Please refresh the page.</p>
      </nav>
    </div>
  </div>
</header>
